module.exports = __webpack_public_path__ + "static/media/samurai.23e89d93.png";